import { CustomValueBulkResponse } from "PFCore/hooks/queries/custom_fields/admin/custom_values_bulk/response";
import { CustomValue } from "PFTypes";

import { SkillsManagementModalType } from "../../parts/modals/import/constants/skills_management_modal_type";
import { useSkillsCustomTypeId } from "../../utils/use_skills_custom_type";
import { useSkillsManagementContext } from "../contexts/skills_management_context_provider";
import { useSkillActions } from "./use_skill_actions";
import { useSkillManagementModal } from "./use_skill_management_modal";

type BulkActions = {
  selectNone: () => void;
  selectedSkills: CustomValue[];
  deleteSelected: () => Promise<CustomValueBulkResponse>;
  approveSelected: () => Promise<CustomValueBulkResponse>;
  blacklistSelected: () => Promise<CustomValueBulkResponse>;
  resetSelected: () => Promise<CustomValueBulkResponse>;
  exportSelected: () => Promise<string>;
  mergeSelected: () => void;
};

export const useBulkActions = (): BulkActions => {
  const { setRowSelectionState, selectedSkills } = useSkillsManagementContext();
  const { approveSkills, deleteSkills, exportSkills, blacklistSkills, resetSkills } = useSkillActions();
  const { openModal } = useSkillManagementModal();

  const customTypeId = useSkillsCustomTypeId();

  const selectNone = () => setRowSelectionState({});

  const skillIds = selectedSkills.map(({ id }) => id);

  const deleteSelected = () => deleteSkills({ customTypeId, ids: skillIds });
  const blacklistSelected = () => blacklistSkills({ customTypeId, ids: skillIds });
  const approveSelected = () => approveSkills({ customTypeId, ids: skillIds });
  const exportSelected = () => exportSkills({ customTypeId, ids: skillIds });
  const resetSelected = () => resetSkills({ customTypeId, ids: skillIds });
  const mergeSelected = () => openModal(SkillsManagementModalType.Merge, { skills: selectedSkills });

  return {
    selectNone,
    selectedSkills,
    deleteSelected,
    blacklistSelected,
    approveSelected,
    resetSelected,
    exportSelected,
    mergeSelected
  };
};
